"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../../utils");
var _professionalExperience = _interopRequireDefault(require("../../../../../utils/prop-types/student/professional-experience"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LaboralButton = function LaboralButton(_ref) {
  var toggleModal = _ref.toggleModal,
    isOpen = _ref.isOpen,
    company = _ref.company,
    experiences = _ref.experiences;
  var title = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(22),
    _useState2 = _slicedToArray(_useState, 2),
    fontSize = _useState2[0],
    setFontSize = _useState2[1];
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (!title) {
        return;
      }
      var titleLineHeight = title.current ? window.getComputedStyle(title.current, null).getPropertyValue('line-height') : 0;
      var offsetHeight = title.current ? title.current.offsetHeight : 0;
      titleLineHeight = parseInt(titleLineHeight, 10);
      var lines = 0;
      if (offsetHeight > 0) {
        lines = offsetHeight / titleLineHeight;
      }
      lines = parseInt(lines, 10);
      var fontSizeTest = 22;
      if (lines > 0) {
        while (lines > 2) {
          fontSizeTest -= 1;
          setFontSize(fontSizeTest);
          titleLineHeight = title.current ? window.getComputedStyle(title.current, null).getPropertyValue('line-height') : 0;
          offsetHeight = title.current ? title.current.offsetHeight : 0;
          titleLineHeight = parseInt(titleLineHeight, 10);
          if (offsetHeight > 0 && titleLineHeight > 0) {
            lines = offsetHeight / titleLineHeight;
          } else {
            lines = 0;
          }
          lines = parseInt(lines, 10);
        }
      }
    }, 1);
  }, [isOpen]);
  var deletePeriod = function deletePeriod(text) {
    var textWithoutPeriod = text;
    var lastCharacter = textWithoutPeriod.charAt(textWithoutPeriod.length - 1);
    while (lastCharacter === '.') {
      var newText = textWithoutPeriod.slice(0, -1);
      textWithoutPeriod = newText;
      lastCharacter = newText.charAt(textWithoutPeriod.length - 1);
    }
    return textWithoutPeriod;
  };
  return /*#__PURE__*/_react.default.createElement(_styled.Button, {
    key: company,
    onClick: function onClick() {
      return toggleModal(company);
    }
  }, /*#__PURE__*/_react.default.createElement(_styled.SpanTitle, {
    ref: title,
    style: {
      fontSize: fontSize
    }
  }, deletePeriod(company)), experiences.map(function (experience) {
    return /*#__PURE__*/_react.default.createElement(_styled.DivExperience, {
      key: experience.id
    }, /*#__PURE__*/_react.default.createElement(_styled.SpanDescription, null, deletePeriod(experience.position)), /*#__PURE__*/_react.default.createElement(_styled.SpanLocation, null, (0, _utils.getExperienceSubtitle)(experience, true)));
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: "small-triangle-alt"
  }));
};
LaboralButton.propTypes = {
  company: _propTypes.default.string.isRequired,
  experiences: _propTypes.default.arrayOf(_professionalExperience.default).isRequired,
  toggleModal: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool.isRequired
};
var _default = LaboralButton;
exports.default = _default;